import { arrayOf, func, shape, string } from 'prop-types'
import { type FC } from 'react'
import { connectSortBy } from 'react-instantsearch-dom'

import { FILTER_FLYOUT_CLOSE } from 'shared/experiments/components/NewSerp/consts'
import FlyoutFilter from 'shared/experiments/components/NewSerp/FlyoutFilter/FlyoutFilter'
import { withSearchStateHandler } from 'shared/experiments/components/NewSerp/helpers'
import { type RefinementListCloseAction } from 'shared/experiments/components/NewSerp/types'
import store from 'shared/store'
import { type InferPropsWithDefaults } from 'shared/utils/propTypes'
import { withI18n } from 'shared/utils/withI18n'
import InputCheckbox from 'views/components/molecules/InputCheckbox/index'

const FlyoutSortBy: FC<ComponentProps> = ({
  items,
  label,
  refine,
  currentRefinement,
}) => {
  return (
    <FlyoutFilter
      attribute="flyoutSortBy"
      label={label}
      active={currentRefinement !== items?.[0]?.value}
    >
      <ul className="a-list-reset u-no-margin-bottom-for-last-child">
        {(items as []).map(({ label: optLabel, value }) => (
          <li key={optLabel} className="u-margin-small--bottom">
            <InputCheckbox
              id={`sort-by-${optLabel}`}
              name={`sort-by-${optLabel}`}
              labelSize="small"
              type="radio"
              value={value === currentRefinement ? 'on' : ''}
              onClick={() =>
                withSearchStateHandler(() => {
                  refine(value)
                  store.dispatch({
                    type: FILTER_FLYOUT_CLOSE,
                    attribute: 'flyoutSortBy',
                  } as RefinementListCloseAction)
                })
              }
            >
              {optLabel}
            </InputCheckbox>
          </li>
        ))}
      </ul>
    </FlyoutFilter>
  )
}

const propTypes = {
  label: string.isRequired,
  items: arrayOf(shape({ label: string, value: string })).isRequired,
  refine: func.isRequired,
  currentRefinement: string.isRequired,
}

const defaultProps = {
  items: [],
}

type ComponentProps = InferPropsWithDefaults<
  typeof propTypes,
  typeof defaultProps
>

export default connectSortBy(withI18n()(FlyoutSortBy))
